module.exports = __webpack_public_path__ + "media/images/challenges/sony-talent-league-edition-ii/circle--red-cropped-bd1ff2eaed9e5fc4f602f5c5e85db18e.png";